import { render, staticRenderFns } from "./FaQManagementUpdate.vue?vue&type=template&id=94c16b06&"
import script from "./FaQManagementUpdate.vue?vue&type=script&lang=js&"
export * from "./FaQManagementUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports